import { motion } from "framer-motion";
import { ArrowRight, Compass } from "lucide-react";
import { IMG } from "@/lib/images";

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative w-full h-screen min-h-[760px] overflow-hidden"
    >
      {/* Hero background — John riding the Road Glide 3 along the coast */}
      <div className="absolute inset-0">
        <img
          src={IMG.RIDE_COAST}
          alt="John riding his 2024 Harley-Davidson Road Glide 3 along the coast"
          style={{ objectPosition: "50% 45%", filter: "brightness(1.14) contrast(1.02)" }}
          className="absolute inset-0 w-full h-full object-cover hero-zoom"
        />
      </div>

      {/* Cinematic grade + dark overlays (lightened so John, the Road Glide 3 and the bag read clearly) */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#2a0f04]/20 via-[#F47A20]/6 to-[#0A0A0C]/40 mix-blend-multiply" />
      <div className="absolute inset-0 bg-black/15" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-[#0A0A0C]/25 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0C]/70 via-[#0A0A0C]/15 to-transparent" />

      {/* Top right marker */}
      <div className="absolute top-28 right-6 md:right-12 z-10 text-right hidden sm:block">
        <div className="serial text-[10px] text-white/40">CHAPTER 001 · THE PROTOTYPE</div>
        <div className="serial text-[10px] text-white/40 mt-1">ESTABLISHED 2026 · AUSTRALIA</div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 md:px-12 flex flex-col justify-end pb-24">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-4xl"
        >
          <div className="flex items-center gap-3 mb-6">
            <span className="section-mark" />
            <span className="overline">A Founder-Led Build · Documented On The Road</span>
          </div>

          <h1 className="h-display text-white text-5xl sm:text-6xl lg:text-[6.5rem]" data-testid="hero-headline">
            The Journey
            <br />
            <span className="text-[#F47A20]">Behind The Bag.</span>
          </h1>

          <p data-testid="hero-subheading" className="mt-8 max-w-xl text-base sm:text-lg text-white/80 leading-relaxed">
            Built by one stubborn rider. Designed for thousands more.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a href="#journey" data-testid="hero-cta-primary" className="btn-primary">
              <Compass size={18} />
              Follow the Journey
            </a>
            <a href="#vip" data-testid="hero-cta-secondary" className="btn-secondary">
              Join the VIP List
              <ArrowRight size={16} />
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/40">
        <span className="serial text-[10px]">CHAPTER 01 BEGINS BELOW</span>
        <div className="w-px h-8 bg-white/20" />
      </div>
    </section>
  );
};
